/**
     * @desc 创建P2P模式会议
仅会产生统一错误码
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {}

export const method = 'PUT';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/v3/meeting/p2p/create', params, 'PUT'),
    newValue,
    shouldRevalidate,
  );
}

export function useDeprecatedRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/meeting/p2p/create',
    params,
    swrOptions,
    { method: 'PUT' },
  );
}

export function request(
  params: Params,
  body: defs.client.P2PMeetingToParameters,
  options?: any,
) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/v3/meeting/p2p/create', params, 'PUT'),
    {
      method: 'PUT',

      body,
      ...options,
    },
  );
}
